import { render, staticRenderFns } from "./quality-price.vue?vue&type=template&id=6b8ff2c2&"
import script from "./quality-price.vue?vue&type=script&lang=js&"
export * from "./quality-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports